<app-table #tableComponent [config]="tableConfig"/>
